<div>
  <div class="header-container">
    Søknaden kan ikke signeres
  </div>
  <div class="content-container">
    Denne byggesøknaden er annullert og lenken fungerer ikke lenger.
  </div>
</div>
